import { createPaginator } from "@smithy/core";
import { ListFeaturesCommand, } from "../commands/ListFeaturesCommand";
import { EvidentlyClient } from "../EvidentlyClient";
export const paginateListFeatures = createPaginator(EvidentlyClient, ListFeaturesCommand, "nextToken", "nextToken", "maxResults");
